<div class="streaming-wrapper">
  <!-- BG overlay -->
  <div class="red-overlay "></div>

  <div class="streaming-container container">
    <div class="main-content">
      <div class="header-content d-flex flex-column">
        <h1 class="title" data-test="title">For the <span class="highlight">Best</span> Experience Stream On Our Apps
        </h1>
        <h2 class="subtitle" data-test="subtitle">Stream and enjoy thousands of events on the big screen or on the go on
          your mobile device.</h2>
      </div>
      <div class="devices" data-test="device-groups">
        <div class="d-flex align-items-center device-group">
          <flo-svg-icon icon="icon-roku" width="3.875em" class="watch-device roku"></flo-svg-icon>
          <flo-svg-icon icon="icon-apple-tv" width="48px" class="watch-device apple-tv"></flo-svg-icon>
        </div>
        <div class="d-flex align-items-center device-group">
          <flo-svg-icon icon="icon-android-tv" width="7em" class="watch-device android-tv"></flo-svg-icon>
          <flo-svg-icon icon="icon-fire-tv" width="3.875em" class="watch-device fire-tv"></flo-svg-icon>
        </div>
      </div>
      <div>
        <h3 class="apps-title" data-test="apps-title">Download the FloSports Mobile App</h3>
        <div class="apps" data-test="apps">
          <div class="app-device">
            <a aria-label="google-play" floAnalytics target="_blank"
              href="https://play.google.com/store/apps/details?id=tv.flosports&hl=en_US&pli=1">
              <flo-svg-icon icon="icon-google-play" width="114px"></flo-svg-icon>
            </a>
          </div>
          <div class="app-device">
            <a aria-label="apple-store" floAnalytics target="_blank"
              href="https://apps.apple.com/us/app/flosports-watch-live-sports/id1149210891">
              <flo-svg-icon icon="icon-app-store" width="114px"></flo-svg-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="content-image">
    <img src="https://d6fm3yzmawlcs.cloudfront.net/funnelAssets/dark-theme/flo-devices-stream-anywhere-2.png">
  </div>
</div>